import { useNavigate, useLocation } from "react-router-dom";

export const useBack = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasBack = location.key !== "default";

  const handleBack = (defaultNav?:string) => {
    if (defaultNav) {
      navigate(defaultNav);
    } else if (hasBack) {
      navigate(-1);
    } else if (!location.pathname.replace(/[^/]*$/, "").slice(0, -1)) {
      navigate("/");
    } else {
      const urlSlicedUpToLastSlash = location.pathname.replace(/[^/]*$/, "").slice(0, -1);
      const lastInstanceofSlash = urlSlicedUpToLastSlash.lastIndexOf("/");
      const result = urlSlicedUpToLastSlash.substring(lastInstanceofSlash + 1);
      if (result === "update") {
        navigate(urlSlicedUpToLastSlash.replace(/[^/]*$/, "").slice(0, -1));
      } else {
        navigate(location.pathname.replace(/[^/]*$/, "").slice(0, -1));
      }
    }
  };

  return { hasBack, handleBack };
};

